<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">姓名</span>
        <el-input v-model.trim="name" placeholder="请输入姓名" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">手机号</span>
        <el-input v-model.trim="phone" placeholder="请输入手机号" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">交易类型</span>
          <el-select v-model="transactionType" class="w150" clearable>
		      <el-option label="请选择" value=""/>
          <el-option label="充值" value="充值"/>
          <el-option label="消费" value="消费"/>
          <el-option label="平账转入" value="平账转入"/>
          <el-option label="平账转出" value="平账转出"/>
        </el-select>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">交易状态</span>
	      <el-select v-model="state" class="w150" clearable>
	  	  <el-option label="请选择" value=""/>
	      <el-option label="预登记" value="预登记"/>
	      <el-option label="交易成功" value="交易成功"/>
	    </el-select>
	  </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">时间类型</span>
          <el-select v-model="timeType" class="w150" clearable>
		      <el-option label="请选择" value=""/>
          <el-option label="交易时间" value="tradingHours"/>
          <el-option label="入账时间" value="entryTime"/>
          <el-option label="创建时间" value="creationTime"/>
        </el-select>
      </div>  

      <div class="dlblock-mb20 mr10">
        <span class="pr5">交易方式</span>
          <el-select v-model="transactionMode" class="w150" clearable>
		      <el-option label="请选择" value=""/>
          <el-option label="农行掌银" value="农行掌银"/>
          <el-option label="生物识别消费" value="生物识别消费"/>
          <el-option label="账户内互转" value="账户内互转"/>
        </el-select>
      </div>      

      
      <div class="dlblock-mb20 mr10">
        <span class="pr5">餐次</span>
          <el-select v-model="meal" class="w150" clearable>
		      <el-option label="请选择" value=""/>
          <el-option label="早餐" value="早餐"/>
          <el-option label="中餐" value="中餐"/>
          <el-option label="晚餐" value="晚餐"/>
        </el-select>
      </div>                         

    <div class="dlblock-mb20 mr10">
	    <span class="pr5">开始时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
			class="reset-clear"
			:clearable="false"
			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始日期"
	        />
	  </div> 
	  

	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
          v-model="updateTime"
		  style="width: 180px;"
          type="datetime"
          :clearable="false"
          unlink-panels
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
           />
	  </div> 

	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getCanteenSmsListPageFn()">
          搜索
        </el-button>
      </div>
	  
	  
	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(2)">
	      上传交易流水
	    </el-button>
	  </div>

	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(3)">
	      月份查看设置
	    </el-button>
	  </div>
	  
<!--  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(4)">
	      交易时间与入账时间对比差异excel导出
	    </el-button>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(5)">
	      刷脸记录与流水正反对比差异数据excel导出
	    </el-button>
	  </div>

	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(9)">
	      时间选择日志与流水正反对比差异数据excel导出
	    </el-button>
	  </div>

	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(6)">
	      流水反补辅助摄像头刷脸记录
	    </el-button>
	  </div>

    <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(10)">
	      时间选择流水反补辅助摄像头刷脸记录
	    </el-button>
	  </div>

	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(7)">
	      流水逆踢刷脸记录
	    </el-button>
	  </div>  

    <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(11)">
	      时间选择流水逆踢刷脸记录
	    </el-button>
	  </div> -->

   <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(8)">
	      导出
	    </el-button>
	  </div>

   <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(12)">
	      同步最近三天的流水
	    </el-button>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	  	<el-button type="primary" @click="editBtn(13)">
	  	      同步全部的流水
	  	</el-button>
	  	</div>
		
		<div class="dlblock-mb20 mr10">
			<el-button type="primary" @click="editBtn(14)">
			      检查刷脸记录与流水不平原因
			</el-button>
		</div>
	  
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
      <el-table-column align="center" prop="name" label="姓名"></el-table-column>
	    <el-table-column align="center" prop="department" label="所属部门"></el-table-column>
      <el-table-column align="center" prop="posMachine" label="POS机"></el-table-column>
	    <el-table-column align="center" prop="cardNumber" label="卡号"></el-table-column>
      <el-table-column align="center" prop="studentNumber" label="手机号"></el-table-column>
	    <el-table-column align="center" prop="transactionType" label="交易类型"></el-table-column>
	    <el-table-column align="center" prop="transactionMode" label="交易方式"></el-table-column>
	    <el-table-column align="center" prop="meal" label="餐次"></el-table-column>
	    <el-table-column align="center" prop="originalAmount" label="原始金额"></el-table-column>
	    <el-table-column align="center" prop="transactionAmount" label="交易金额"></el-table-column>
      <el-table-column align="center" prop="creationTime" label="创建时间"></el-table-column>
	    <el-table-column align="center" prop="tradingHours" label="交易时间"></el-table-column>
	    <el-table-column align="center" prop="entryTime" label="入账时间"></el-table-column>
      <el-table-column align="center" prop="state" label="状态"></el-table-column>
	    <el-table-column align="center" prop="businessFlow" label="业务流水"></el-table-column>
	    <el-table-column align="center" prop="transactionSummary" label="交易摘要"></el-table-column>
	    <el-table-column align="center" prop="causeOfError" label="错误原因"></el-table-column>
      <el-table-column align="center" prop="operator" label="操作员"></el-table-column>

     <!-- <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a"  @click="editBtn(2, row)">修改</a>
          <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
		   <a class="glob-a"  @click="editBtn(5, row)">删除</a>
        </template>
      </el-table-column> --> 
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

 
  <!-- 上传银行食堂员工余额发送短信 -->
    <el-dialog :title="editData.add === 1 ? '上传用户余额发送短信' : '编辑'" :visible.sync="editData.modal" width="500px">
      <el-form label-width="150px">
        <el-form-item label="文件：">
			<el-row>
			  <word-img class="mr10 mb10" v-model="editData.picture" :balance="balance" :total="1"/>
			</el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
	
	<!-- 上传食堂银行交易流水 -->
	  <el-dialog :title="canteen.add === 1 ? '上传银行食堂交易流水' : '编辑'" :visible.sync="canteen.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
				<el-row>
				  <trans-action class="mr10 mb10" v-model="canteen.picture" :balance="balance" :total="1"/>
				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>


    
    	<!-- 上传人脸识别日志一楼 -->
	  <el-dialog :title="faceRecognitionLog.add === 1 ? '上传人脸识别日志一楼' : '编辑'" :visible.sync="faceRecognitionLog.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
				<el-row>
				  <face-reco class="mr10 mb10" v-model="faceRecognitionLog.picture" :balance="balance" :total="1"/>
				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>
	  
    <!-- 月份查看设置 -->
    <el-dialog title="月份查看设置" :visible.sync="friendData.modal"  width="400px">
      <el-form label-width="320px">
        <span class="pr5">时间</span>
	       <el-date-picker
	         v-model="timeSetting"
	         style="width: 280px;"
	         type="month"
	         value-format="yyyy-MM"
	        />
      </el-form>

      <div slot="footer">
        <el-button @click="friendData.modal = false">取 消</el-button>
        <el-button type="primary" @click="getTransactionAndEntryTimeSetUpChangeFn()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
  getNhTransactionFlowListPage,
  getTransactionAndEntryTimeSetUpSee,
  getTransactionAndEntryTimeSetUpChange,
  getFlowingTransactionEntry,
  journalAndRunningWaterCaSupplementaryIdentificationRecord,
  //同步最近三天的流水
  getSynTheFlowOfTheLastThreeDays,
  //同步全部的流水
  getSynAllStreams,
  //检查刷脸记录与流水不平原因
  getCheckTheFaceBrushingRecordAndTheCauseOfUnevenWaterFlow
  } from '@/api'

  //导出文件专用
   import {getNhTransactionFlowListExport,
   journalAndRunningWaterCa,
   journalAndRunningWaterCaTime,
   journalAndRunningWaterCaSupplementaryIdentificationRecordTime,
   journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackTime} from '@/api/indexUtil'

   import WordImg from '@/components/agriculturalBankFile.vue'
   import TransAction from '@/components/transactionFlowBankFile.vue'
   import FaceReco from '@/components/faceRecognitionLog.vue'

  export default {
    name: 'WordList',
    components: {WordImg,TransAction,FaceReco},
    data () {
      return {
        //餐次
        meal:"",
        //时间类型
        timeType:"",
        balance:10,
        //交易时间与入账时间设置查看月份
        timeSetting:'',
        //交易类型
        transactionType:'',
		//交易状态
		state:'',
        //交易方式
        transactionMode:'',
        name:'',
        phone:'',
        batch:'',
        createTime:'',
		    updateTime:'',
		    word:'',
		    chinese:'',
        date: '',
        userName: '',
        tableData: [],
        tableLoading: false,
        auditData: {
          modal: false,
          data: {},
          type: 'PASS',
          content: ''
        },
        auditShow: {
          modal: false,
          data: {}
        },
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
		//银行食堂上传交易流水
		canteen: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
     //银行食堂上传人脸识别日志一楼
		faceRecognitionLog: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		//交易流水统计早中晚合计笔数合计金额
        friendData: {
          modal: false,
          ratio: '',
          content: ''
        },
      }
    },
     watch: {
            // 如果 `question` 发生改变，这个函数就会运行
            balance: function () {               
                
            }
        },
    created () {
      this.getCanteenSmsListPageFn()
    },
    methods: {
      getCanteenSmsListPageFn () {
        this.tableLoading = true
        getNhTransactionFlowListPage({
          pageNum: this.pages.page,
          createTime: this.createTime,
          updateTime: this.updateTime,
          name: this.name,
          studentNumber: this.phone,
          transactionType:this.transactionType,
          transactionMode:this.transactionMode,
		  state:this.state,
          timeType:this.timeType,
          meal:this.meal
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getNhTransactionFlowListExportFn(){
        this.tableLoading = true
        getNhTransactionFlowListExport({
          pageNum: this.pages.page,
          createTime: this.createTime,
          updateTime: this.updateTime,
          name: this.name,
          studentNumber: this.phone,
          transactionType:this.transactionType,
          transactionMode:this.transactionMode,
          timeType:this.timeType,
          meal:this.meal
        }).then(res => {	
          this.downloadFile(res)
        }).finally(() => {
          this.tableLoading = false
        }) 
      },
        // 文件下载导出
        downloadFile(res) {
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', '交易流水.xls');
        document.body.appendChild(link);
        link.click()
      },
      //月份查看设置
      getTransactionAndEntryTimeSetUpSeeFn(){
        this.tableLoading = true
        getTransactionAndEntryTimeSetUpSee({id:'d011a9a61bbdb9838b2b288d851098c9'}).then(res => {
          this.timeSetting = res.data;
        }).finally(() => {
          this.tableLoading = false
        })
      },
      //月份查看设置 改变
      getTransactionAndEntryTimeSetUpChangeFn(){
        this.tableLoading = true
        getTransactionAndEntryTimeSetUpChange({id:'d011a9a61bbdb9838b2b288d851098c9',time:this.timeSetting}).then(res => {
          if(res.data){
             this.friendData = {
                modal: false,
                ratio: '',
                content: ''
              }
          }
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  journalAndRunningWaterCaFn(){
		  this.tableLoading = true
		  journalAndRunningWaterCa().then(res => {
        this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
    },
    journalAndRunningWaterCaTimeFn(){
		  this.tableLoading = true
		  journalAndRunningWaterCaTime({
          createTime: this.createTime,
          updateTime: this.updateTime,
      }).then(res => {
        this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
    },
	//同步最近三天的流水
	getSynTheFlowOfTheLastThreeDaysFn(){
		  this.tableLoading = true
		  getSynTheFlowOfTheLastThreeDays().then(res => {
	    this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
	},
	//同步全部的流水
	getSynAllStreamsFn(){
		this.tableLoading = true
		  getSynAllStreams().then(res => {
		this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
	},
	//检查刷脸记录与流水不平原因
	getCheckTheFaceBrushingRecordAndTheCauseOfUnevenWaterFlowFn(){
		this.tableLoading = true
		  getCheckTheFaceBrushingRecordAndTheCauseOfUnevenWaterFlow().then(res => {
		  //this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
	},
	//时间选择流水反补辅助摄像头刷脸记录
    journalAndRunningWaterCaSupplementaryIdentificationRecordTimeFn(){
      this.tableLoading = true
		  journalAndRunningWaterCaSupplementaryIdentificationRecordTime({
          createTime: this.createTime,
          updateTime: this.updateTime,
      }).then(res => {
        this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
    },
    //时间选择流水逆踢刷脸记录
    journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackTimeFn(){
      this.tableLoading = true
		  journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackTime({
          createTime: this.createTime,
          updateTime: this.updateTime,
      }).then(res => {
        this.downloadFile(res)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
    },
	  //流水反补辅助摄像头刷脸记录
	  journalAndRunningWaterCaSupplementaryIdentificationRecordFn(){
		  this.tableLoading = true
		  journalAndRunningWaterCaSupplementaryIdentificationRecord().then(res => {
		   this.$message.success(res.msg)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
	  },
	  //流水逆踢刷脸记录
	  journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackExportFn(){
		  this.tableLoading = true
		  journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackExport({}).then(res => {
        this.$message.success(res.msg)
		  }).finally(() => {
		    this.tableLoading = false
		  })	
	  },
	  getFlowingTransactionEntryFn () {
	    this.tableLoading = true
	    getFlowingTransactionEntry().then(res => {
	     this.$message.success(res.msg)
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6图片检查并下载
		  if(t == 1){
        //上传用户余额发送短信通知
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			 }
		  }else if(t == 2){
        //上传银行食堂交易流水
			  console.info(row,"上传银行食堂交易流水")
			  this.canteen = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			  }
		  }else if(t == 3) {
        //交易流水统计早中晚合计笔数合计金额
	      this.friendData = {
                modal: true,
                ratio: '',
                content: ''
              }
        this.getTransactionAndEntryTimeSetUpSeeFn();
	    }else if(t == 4) {
		//上传人脸识别日志二楼	
	  this.$confirm(`确认交易入账对比差异excel导出吗`, '提示', {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	       this.getFlowingTransactionEntryFn();
		});	
	    }else if(t == 5){
			this.$confirm(`确认日志与流水正反对比差异数据excel导出吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.journalAndRunningWaterCaFn();
			});	
		}else if(t == 6){
			//流水反补摄像头刷脸记录
			this.$confirm(`确认流水反补摄像头刷脸记录吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.journalAndRunningWaterCaSupplementaryIdentificationRecordFn();
			});	
		}else if(t == 7){
			//流水逆踢刷脸记录
			this.$confirm(`确认流水逆踢刷脸记录吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackExportFn()
			});	
		}else if(t == 8){
			//导出excel
			this.$confirm(`确认导出交易吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.getNhTransactionFlowListExportFn();
			});	
		}else if(t == 9){
			//时间选择日志与流水正反对比差异数据excel导出
			this.$confirm(`确认时间选择日志与流水正反对比差异数据excel导出吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.journalAndRunningWaterCaTimeFn();
			});	
		}else if(t == 10){
			//时间选择流水反补辅助摄像头刷脸记录
			this.$confirm(`确认时间选择流水反补辅助摄像头刷脸记录excel导出吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.journalAndRunningWaterCaSupplementaryIdentificationRecordTimeFn();
			});	
		}else if(t == 11){
			//时间选择流水逆踢刷脸记录
			this.$confirm(`确认时间选择流水逆踢刷脸记录excel导出吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackTimeFn();
			});	
		}else if(t == 12){
			//同步最近三天的流水
			this.$confirm(`确认同步最近三天的流水吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.getSynTheFlowOfTheLastThreeDaysFn();
			});	
		}else if(t == 13){
			//同步全部的流水
			this.$confirm(`确认同步全部的流水吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.getSynAllStreamsFn();
			});	
		}else if(t == 14){
			//检查刷脸记录与流水不平原因
			this.$confirm(`确认检查刷脸记录与流水不平原因吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.getCheckTheFaceBrushingRecordAndTheCauseOfUnevenWaterFlowFn();
			});	
		}
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
	    addOrEditWordform({
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getCanteenSmsListPageFn()
	    })
	  } else {
	    addOrEditWordform({
	      id: this.editData.id,
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getCanteenSmsListPageFn()
	    })
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
  pageChange (val) {
        this.pages.page = val
        this.getCanteenSmsListPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
